module.exports = __webpack_public_path__ + "img/icon_liaoban.eff55cb5.png";